(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 *
 * @file      _common.js
 *
 * @abstract ユーザーエージェントを取得してtouchstart, touchmove, touchendに対応するイベントをブラウザごとに振り分ける
 *
 * @author    Yoshiyuki Nakagawa
 * @updated   18/09/2015
 *
 * @see       http://stackoverflow.com/questions/8348139/detect-ios-version-less-than-5-with-javascript
 *            http://qiita.com/Evolutor_web/items/655c6402aece800fd081
 *
 */

'use strict';

/**
 *
 * 共通変数の定義
 *
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var commonVars = exports.commonVars = function () {

  // userAgentの判定
  var ua = function () {
    return {
      Touch: typeof document.ontouchstart != 'undefined',
      Pointer: window.navigator.pointerEnabled,
      MSPoniter: window.navigator.msPointerEnabled
    };
  }();

  // イベント名の割り当て
  var start = ua.Pointer ? 'pointerdown' : ua.MSPointer ? 'MSPointerDown' : ua.Touch ? 'touchstart' : 'mousedown';
  var move = ua.Pointer ? 'pointermove' : ua.MSPointer ? 'MSPointerMove' : ua.Touch ? 'touchmove' : 'mousemove';
  var end = ua.Pointer ? 'pointerup' : ua.MSPointer ? 'MSPointerUp' : ua.Touch ? 'touchend' : 'mouseup';
  var cancel = ua.Pointer ? 'pointercancel' : ua.MSPointer ? 'MSPointerOut' : ua.Touch ? 'touchcancel' : 'mouseout';

  // userAgentに応じてscrollTopさせる要素を振り分け
  var scrollElement = function () {
    var ua = window.navigator.userAgent.toLowerCase();
    // Returns 'body' for Chrome and Safari, 'html' for Firefox and IE
    return ua.indexOf('chrome') != -1 || ua.indexOf('safari') != -1 ? 'body' : 'html';
  }();

  // public APIs
  return {
    ua: ua,
    touch: {
      start: start,
      move: move,
      end: end,
      cancel: cancel
    },
    scroll: {
      elm: scrollElement
    }
  };
}();

},{}],2:[function(require,module,exports){
/**
 *
 * @file      _menu.js
 *
 * @description
 *    opacityChangeクラスをもつ要素がタップされたらtappedクラスを追加する
 *    CSSでopacityを変化させるアニメーションを登録することでタップに反応させる
 *
 * @updated   13/11/2015
 *
 */
'use strict';

var _common = require('./_common.js');

$(document).ready(function (ev) {
    $('.opacityChange').on(_common.commonVars.touch.start, function (ev) {
        var _this = this;

        $(this).addClass('tapped');
        setTimeout(function () {
            $(_this).removeClass('tapped');
        }, 250);
    });
});

},{"./_common.js":1}],3:[function(require,module,exports){
/**
 *
 * @file top.js
 *
 */
'use strict';

require('../../../../../BIS_KYOTO/BIS_KYOTO/common/js/custom/_opacityChange.js');

// import './_countDown.js'

/**
 *
 * 各コンテンツをLightBox風に表示させる
 *
 */
var anchorElms = [{
  anchor: '.present',
  target: '#lightbox_present'
}, {
  anchor: '.about',
  target: '#lightbox_about'
}, {
  anchor: '.flow',
  target: '#lightbox_flow'
}, {
  anchor: '.recommend',
  target: '#lightbox_recommend'
}, {
  anchor: '.faq',
  target: '#lightbox_faq'
}];

anchorElms.forEach(function (elm, idx, arr) {
  //show-panelボタンをクリックしたらLightBoxを表示する
  $(elm.anchor).click(function () {
    $(".BlackWindow").fadeIn(300); /*表示速度は数値を調整*/
    $(elm.target).fadeIn(300); /*表示速度は数値を調整*/
  });
  //CloseボタンをクリックしたらLightBoxを閉じる
  $(".close-panel").click(function () {
    $(".BlackWindow").fadeOut(300); /*フォードアウトの速度は数値を調整*/
    $(elm.target).fadeOut(300); /*表示速度は数値を調整*/
  });
  //背景の黒地をクリックしたらLightBoxを閉じる
  $(".BlackWindow").click(function () {
    $(".BlackWindow").fadeOut(300); /*フォードアウトの速度は数値を調整*/
    $(elm.target).fadeOut(300); /*表示速度は数値を調整*/
  });
});

/**
 *
 * 締め切りを過ぎていれば_expire.htmlを表示させる
 *
 */
var today = new Date();
// 例えば2016年1月4日23:59分締め切りの場合は'2016-01-05T00:00:00+0900'にする
var limit = new Date('2017-01-23T15:00:00');
if (today.getTime() > limit.getTime()) {
  document.getElementById('expire').setAttribute('style', 'display:block');
}

},{"../../../../../BIS_KYOTO/BIS_KYOTO/common/js/custom/_opacityChange.js":2}]},{},[3]);
